import React, { useState } from "react";
import { Button, Grid, TextField, Box } from "@material-ui/core";
const KapLinkDailogContent = ({
  closeKapDailog,
  afterEnteringKapLink,
  varId,
}) => {
  const [kapLinkInput, setKapLinkInput] = useState("");
  const [emptyErr, setEmptyErr] = useState(false);
  const addEnteredKap = () => {
    if (kapLinkInput.trim() !== '') afterEnteringKapLink(kapLinkInput, varId);
    else setEmptyErr(true);
  };
  return (
    <div>
      <Grid container spaceing={3}>
        <Grid item sm={12}>
          <TextField
            required
            variant="outlined"
            id="kap-link"
            label="Kap Link"
            value={kapLinkInput}
            onChange={(e) => {
              setKapLinkInput(e.target.value);
              setEmptyErr(false);
            }}
            fullWidth
            margin="normal"
          />
          {emptyErr && (
            <span
              style={{ position: "relative", top: "-6px", color: "#d32f2f" }}
            >
              Required *
            </span>
          )}
        </Grid>
        <Grid item sm={12}>
          <Box display="flex" justifyContent="flex-end" sx={{ mt: 4 }}>
            <Button
              onClick={closeKapDailog}
              variant="outlined"
              style={{ marginRight: "1rem" }}
            >
              Close
            </Button>
            <Button
              onClick={addEnteredKap}
              variant="outlined"
              style={{
                backgroundColor: "#622AD8",
                color: "white",
                "&:hover": {
                  backgroundColor: "#303f9f",
                },
              }}
            >
              Add
            </Button>
          </Box>
        </Grid>
        {/* <Grid item sm={6}>
        </Grid> */}
      </Grid>
    </div>
  );
};
export default KapLinkDailogContent;
